import { Tag } from 'antd';
import { linkCell } from 'utils/cell-formatter';

const STATUS_LABELS: Record<number, { label: string; color: string }> = {
  1001: { label: 'Draft', color: 'default' },
  1002: { label: 'Published', color: 'green' },
};

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/subscriptions' }),
  },
  {
    accessorKey: 'slug',
    header: 'Slug',
    cell: ({ getValue }) => getValue() || '-',
  },
  {
    accessorKey: 'title',
    header: 'Title',
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ getValue }) => {
      const status = getValue();
      const meta = STATUS_LABELS[status];
      return meta ? (
        <Tag color={meta.color}>{meta.label}</Tag>
      ) : (
        status
      );
    },
  },
];
